import React, { useMemo } from 'react';
import { richTextToHtml } from '../functions/rich_text.helper';

// Drop-in replacement for the old `<ReactQuill readOnly theme={null} .../>` display usage.
// Renders a stored value in ANY legacy format (plain text / Quill Delta JSON / HTML).
const RichTextViewer = ({ value, className, style, }) => {
    const html = useMemo(() => richTextToHtml(value), [value]);

    if (!html) return null;

    return (
        <div
        className={className}
        style={style}
        dangerouslySetInnerHTML={{ __html: html, }}
        />
    );
}

export default RichTextViewer;
